<template>
  <div class="data-details__date-item">
    <p v-show="displayDesc && date.description" class="mb-1">{{ date.description }}:</p>
    <div class="d-flex">
      <div class="text-nowrap">{{ startDate }}</div>
      <div v-show="endDate && startDate !== endDate" class="text-nowrap ml-1">- {{ endDate }}</div>
    </div>
    <div v-if="!showStartDateTimeInOneLine && startTime" class="d-flex">
      <div class="text-nowrap">{{ startTime }}</div>
      <div v-show="endTime && startTime !== endTime" class="text-nowrap ml-1">- {{ endTime }}</div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatTime } from '@/helpers/dateTimeHelper';

export default {
  name: 'DataItemInfoDateItem',
  props: {
    date: {
      type: Object,
      required: true,
    },
    displayDesc: {
      type: Boolean,
      default: true,
    },
    displayTime: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    startDate() {
      const startDate = formatDate(this.date.start_date);

      return this.showStartDateTimeInOneLine && this.startTime ? `${startDate}, ${this.startTime}` : startDate;
    },
    startTime() {
      return this.displayTime ? formatTime(this.date.start_date) : null;
    },
    showStartDateTimeInOneLine() {
      return !this.endDate;
    },
    endDate() {
      return formatDate(this.date.end_date);
    },
    endTime() {
      return this.displayTime ? formatTime(this.date.end_date) : null;
    },
  },
};
</script>
